import injectReducer from 'store/injectReducer';
import {
	failureActionHandler,
	requestActionHandler,
	successActionHandler,
} from 'store';
import {
	ITemplatesReducer,
	ITemplate,
	ITemplateList,
	ITemplateData,
} from 'modules/admin-panel/pages/templates/models';
import * as types from 'modules/admin-panel/pages/templates/ActionTypes';

export const InitialTemplatesReducer: ITemplatesReducer = {
	isLoading: false,
};

export default injectReducer(InitialTemplatesReducer, {
	[types.GET_TEMPLATE_LIST.REQUEST]: requestActionHandler,

	[types.GET_TEMPLATE_DATA.REQUEST]: requestActionHandler,
	[types.POST_TEMPLATE.REQUEST]: requestActionHandler,
	[types.POST_MINIMAL_TEMPLATE.REQUEST]: requestActionHandler,
	[types.PATCH_TEMPLATE_DATA.REQUEST]: requestActionHandler,
	[types.DELETE_TEMPLATE.REQUEST]: requestActionHandler,

	[types.GET_TEMPLATE_LIST.FAILURE]: failureActionHandler,

	[types.GET_TEMPLATE_DATA.FAILURE]: failureActionHandler,
	[types.POST_TEMPLATE.FAILURE]: failureActionHandler,
	[types.POST_MINIMAL_TEMPLATE.FAILURE]: failureActionHandler,
	[types.PATCH_TEMPLATE_DATA.FAILURE]: failureActionHandler,
	[types.DELETE_TEMPLATE.FAILURE]: failureActionHandler,

	[types.GET_TEMPLATE_LIST.SUCCESS]: (
		state: ITemplatesReducer,
		{ payload }: { payload: ITemplateList },
	) => ({
		...successActionHandler(state),
		templateList: payload,
	}),

	[types.GET_TEMPLATE_DATA.SUCCESS]: (
		state: ITemplatesReducer,
		{ payload }: { payload: ITemplateData },
	) => ({
		...successActionHandler(state),
		templateData: payload,
	}),

	[types.POST_TEMPLATE.SUCCESS]: (
		state: ITemplatesReducer,
		{ payload }: { payload: ITemplateList },
	) => ({
		...successActionHandler(state),
		templateData: payload,
		isTemplateCreated: true,
	}),

	[types.POST_MINIMAL_TEMPLATE.SUCCESS]: (
		state: ITemplatesReducer,
		{ payload }: { payload: ITemplate },
	) => ({
		...successActionHandler(state),
		template: payload,
	}),

	[types.PATCH_TEMPLATE_DATA.SUCCESS]: (state: ITemplatesReducer) => ({
		...successActionHandler(state),
		isTemplateUpdated: true,
	}),

	[types.DELETE_TEMPLATE.SUCCESS]: (
		state: ITemplatesReducer,
		{
			payload: { deletedTemplateId, showAlert },
		}: { payload: { deletedTemplateId: number; showAlert: boolean } },
	) => ({
		...successActionHandler(state),
		templateList: state?.templateList?.filter(
			({ id }) => id !== deletedTemplateId,
		),
		isTemplateDeleted: showAlert,
	}),

	[types.RESET_TEMPLATE_DATA]: (
		state: ITemplatesReducer,
	): ITemplatesReducer => ({
		...successActionHandler(state),
		templateData: undefined,
		isTemplateCreated: false,
	}),

	[types.RESET_MINIMAL_TEMPLATE]: (
		state: ITemplatesReducer,
	): ITemplatesReducer => ({
		...successActionHandler(state),
		template: undefined,
		isTemplateDeleted: undefined,
	}),

	[types.RESET_UPDATED_TEMPLATE]: (state: ITemplatesReducer) => ({
		...successActionHandler(state),
		isTemplateUpdated: undefined,
	}),

	[types.RESET_TEMPLATES_ERROR]: (
		state: ITemplatesReducer,
	): ITemplatesReducer => ({
		...successActionHandler(state),
	}),

	[types.RESET_TEMPLATE_DELETED]: (state: ITemplatesReducer) => ({
		...successActionHandler(state),
		isTemplateDeleted: undefined,
	}),
});
